module.exports = {
	"base": {
		"welcome": "Croeso i Mulligans, %{name}!",
		"user": "Gwybodaeth Defnyddiwr",
		"devices": "Dyfeisiau",
		"refunds": "Ad-daliadadau",
		"resources": "Adnoddau",
		"transactions": "Archebion a Dychweliadau",
		"email": "E-bost",
		"password": "Cyfrinair",
		"save": "Cadw",
		"sign-out": "Allgofnodi",
		"cancel": "Canslo",
		"close": "Cau",
		"learn-more": "Dysgwch fwy",
		"required": "a Fynnir",
		"support": "Cymorth",
		"bookshelf": "Bookshelf",
		"launch": "Lansio",
		"download": "Llwytho i Lawr",
		"details": "Manylion",
		"cannot-be-blank": "Ni all %{field} fod yn wag.",
		"saving": "Yn arbed...",
		"done": "Wedi gorffen",
		"failed": "Wedi methu",
		"copy": "Copïo"
	},
	"signin": {
		"login-failure": "Mae'r e-bost neu'r cyfrinair yn anghywir",
		"welcome-large": "Croeso i  <span class='inner'>Ganolfan Cyfrif %{brand}</span>",
		"welcome-small": "<span class='inner'>Canolfan Gyfrif</span>",
		"signin-button": "Mewngofnodi",
		"forgot-password": "Ydych chi wedi anghofio eich cyfrinair?",
		"new-to-vst": "Ydych chi'n newydd i %{brand}?",
		"create-account": "Crëwch gyfrif",
		"signing-in": "Mewngofnodi...",
		"signin-failed": "Ni wnaethoch fewngofnodi'n llwyddianus"
	},
	"transactions": {
		"price": "Pris",
		"excluded": "(Ac eithrio treth)",
		"quantity": "Maint",
		"confirmation#": "Cadarnhad #",
		"payment": "Taliad",
		"purchased": "Wedi'u prynu",
		"purchase-details": "Manylion Taliad",
		"subtotal": "Is-gyfanswm",
		"total": "Cyfanswm",
		"tax": "Treth",
		"loading": "Helo siopwr! Rydym ni'n llwytho eich pryniannau ...",
		"no-purchases": "Nid oes gennych unrhyw bryniannau.",
		"seller-vat": "TAW y gwerthwr",
		"total-vat": "Cyfanswm %{vat} TAW a Dalwyd",
		"portion": "%{subTax} Tax %{rate}%",
		"vat-disclosure": "Mae'r Pris yn Cynnwys %{vat}",
		"purchases": "Pryniannau",
		"refunded-items": "Eitemau Wedi'u Had-dalu",
		"book-title": "Teitl y Llyfr",
		"refund-details": "Manylion Ad-daliad",
		"print-receipt": "Argraffwch Dderbynneb",
		"request-refund": "Gwnewch Gais am Ad-daliad",
		"expired": "Wedi dod i ben",
		"expires-in": "Mae'n dod i ben ar %{date}",
		"details-refund": "Manylion ac Ad-daliad",
		"modal": {
			"cant-refund-title": "Nid oes Ad-daliad ar Gael",
			"cant-refund": "Ni ellir ad-dalu eich llyfr o ganlyniad i un o'r rhesymau canlynol:",
			"cant-refund-1": "Mae gormod o'ch llyfr wedi'u gweld.",
			"cant-refund-2": "Mae mwy na 14 diwrnod wedi mynd heibio ers i'r dyddiad prynu.",
			"cant-refund-3": "Datgelir eich cod adnoddau ar-lein.",
			"cant-refund-4": "Mae eich llyfr wedi'i ad-dalu yn flaenorol.",
			"cant-refund-5": "Mae pob cod eisoes wedi ei ddefnyddio a/neu ei ad-dalu.",
			"cant-refund-6": "Mae hi wedi bod mwy na 30 diwrnod o'r dyddiad prynu.",
			"cant-refund-support": "Os ydych chi'n dal i fod yn ansicr o bolisi ad-dalu %{brand}, cysylltwch â'n <a href='%{support_url}' target='_blank'> tîm cefnogi</a>."
		},
		"license": {
			"perpetual": "Nid yw mynediad ar-lein yn dod i ben",
			"days": "Mynediad %{days} diwrnod"
		}
	},
	"devices": {
		"description": "Mae %{brand} yn eich caniatáu i <span>actifadu cyfrifiaduron %{desktop}</span>  a dyfeisiau symudol  <span>%{mobile}</span> ar unrhyw adeg.",
		"loading": "Helo! Rydym ni'n dod o hyd i'ch dyfeisiau :)",
		"no-active": "Nid oes gennych ddyfeisiau sydd wedi'u hactifadu.",
		"deactivate": "Dirymu"
	},
	"user": {
		"personal-information": "Gwybodaeth Bersonol",
		"security-information": "Gwybodaeth am Ddiogelwch",
		"notifications": "Hysbysiadau",
		"first-name": "Enw cyntaf",
		"last-name": "Cyfenw",
		"change-password-title": "Newidiwch eich Cyfrinair",
		"current-password": "Cyfrinair presennol",
		"new-password": "Cyfrinair Newydd",
		"security-password": "Cyfrinair",
		"confirm-new-password": "Cadarnhau'r Cyfrinair Newydd",
		"security-question": "Cwestiwn Diogelwch",
		"security-info-change": "Newid",
		"question": "Cwestiwn",
		"answer": "Ateb",
		"notifications-text": "E-bostiwch ddiweddariadau achlysurol am fy ngweithgareddau ar fy nghyfrif, diweddariadau am gynhyrchion, a chynigion arbennig.",
		"loading": "Mae Spot yn chwilio am eich gwybodaeth defnyddiwr, arhoswch eiliad",
		"change-password-text": "Rhaid i gyfrinair gynnwys o leiaf 8 cymeriad, priflythyren, a chymeriad arbennnig.",
		"email-locked": "E-bost ar Glo",
		"email-locked-description": "Nid oes gennych fynediad i newid eich e-bost.",
		"email-locked-more": "Cysylltwch â'ch gweinyddwr.",
		"security-question6": "Beth yw eich hoff chwaraeon?",
		"security-question7": "Beth yw eich hoff flas hufen iâ?",
		"security-question8": "Beth yw enw eich hoff anifail anwes?",
		"security-question9": "Pan oeddech yn ifancach, beth oeddech eisiau bod ar ôl tyfu i fyny?",
		"security-question10": "Beth oedd cyfenw eich hoff athro?",
		"new-password-failure": "Nid yw'r cyfrinair yn bodloni'r gofynion",
		"confirm-password-failure": "Rhaid i'r cyfrinair gyd-fynd",
		"new-password-tooltip": "Rhaid iddo gynnwys o leiaf 8 cymeriad, priflythyren, llythyren fach, a chymeriad arbennig.",
		"enter-valid-email": "Nodwch e-bost dilys.",
		"password-cannot-be-same": "Ni all y cyfrinair fod yr un peth na'r cyfrinair blaenorol",
		"incorrect-password": "Cyfrinair Anghywir",
		"complete-account": "Mae'n edrych yn debyg eich bod angen <a href='%{href}'>cwblhau'ch cyfrif</a>.",
		"completing-allows": "Mae cwblhau'ch cyfrif yn caniatáu ichi ddarllen llyfrau all-lein ar ein hapiau symudol a rhannu nodiadau ac amlygiadau â ffrindiau.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Cynorthwywyr",
		"access-codes": "Codau Mynediad",
		"print-on-demand": "Argraffu Ar Alw",
		"check-pod": "Gwiriwch opsiynau printio cyhoeddwr ar gyfer eich llyfrau.",
		"check-now": "Gwiriwch nawr",
		"loading": "Aroswch eiliad; rydym ni'n diweddaru eich adnoddau!",
		"in": "yn",
		"access-code-intro": "Cod mynediad yw cyfrinair yr ydych chi'n ei ddefnyddio i gael mynediad i gynnwys cwrs ar-lein. Unwaith yr ydych chi'n datgelu cod ar gyfer eitem, ni fyddwch chi'n gallu ei ddychwelyd. I gael mwy o gyfeiriadau ar sut i ddefnyddio eich codau mynediad, ewch i <a href='%{support_url}' target='_blank'>Gefnogaeth</a>.",
		"expires": "Mae'n dod i ben.",
		"expiration-message": "Mae'n cynnwys cyfeiriadau ar gyfer defnyddio eich cod mynediad.",
		"copy-fail": "Nid yw'n bosib ei gopïo. Dewiswch y cod a'i gopio â dwylo.",
		"launch-site": "Lansiwch y Safle",
		"launch-book": "Lansio Llyfr",
		"reveal-code": "Datgelwch Gôd",
		"no-resources": "Nid oes gennych unrhyw adnodd.",
		"no-access-codes": "Nid oes gennych unrhyw godau mynediad.",
		"no-ancillaries": "Nid oes unrhyw beth ategol ar gyfer y teitl hwn",
		"name": "Enw",
		"type": "Teip",
		"size": "Maint",
		"download-all": "Lawrlwytho Popeth",
		"back": "Yn ôl i adnoddau"
	},
	"refunds": {
		"states": {
			"refunded": "Ad-dalwyd",
			"unavailable": "Nid yw Ad-daliad ar Gael"
		},
		"reasons": {
			"dropped": "Rydw i wedi rhoi'r gorau i'r cwrs",
			"wrong": "Nid oedd y llyfr hwn yn addas i fy nghwrs i",
			"print": "Penderfynais i brynu fersiwn caled yn lle.",
			"missing": "Nid yw'r llyfr yn cynnwys popeth sydd angen arnaf ar gyfer fy nghwrs (e.e. CD, mynediad we, fideos)",
			"other": "Arall"
		},
		"bulk": {
			"policy": "Trwy glicio ar y botwm &quot;Cwblhau Ad-daliad&quot; isod, rydw i'n cytuno â pholisi ad-dalu'r %{brand}. <a href='%{policy_url}' target='_blank'></a>",
			"complete": "Ad-daliad Llawn",
			"view-details": "Gweld Manylion yr Ad-daliad",
			"success": "Gofynnwyd am eich ad-daliad. Arhoswch 48 awr ar gyfer prosesu os gwelwch yn dda.",
			"failure": "Wps - aeth rhywbeth o'i le! Yn anffodus ni aeth eich ad-daliad fynd trwodd.",
			"retry": "Trïwch Eto",
			"support": "Cysylltu â'r tîm Cymorth",
			"available-codes": "Codau Ar Gael",
			"codes-selected": "Codau a Ddewiswyd",
			"download": "Lawrlwytho Codau",
			"partially-refunded": "Wedi'i Ad-dalu'n Rhannol",
			"pick-one": "Mae rhaid i chi ddewis o leiaf un cod er mwyn gwneud ad-daliad"
		},
		"refund": "Ad-daliad",
		"all": "Ad-dalu pob un?",
		"missing-reason": "Rhaid i chi ddewis rheswm er mwyn mynd yn eich blaen",
		"missing-elaboration": "Manylwch, os gwelwch chi'n dda",
		"policy": "Drwy glicio \"Cwblhau Cais am Ad-daliad\" isod, rwy'n deall ni fyddaf yn gymwys i wneud cais am unrhyw ad-daliadau pellach ar gyfer yr un llyfr electronig. Gwelwch y polisi dychwelyd yn llawn.",
		"refunded": "Ad-dalwyd",
		"sorry": "Rydym ni'n ymddiheuro nad oeddech chi'n hapus gyda'ch pryniad.",
		"error": "Roedd rhywbeth o'i le",
		"error-explain": "Nid oedd yn bosib i ni brosesu eich ad-daliad. Ceisiwch eto.",
		"why": "Beth yw eich rhesymau dros wneud cais am ad-daliad?",
		"no-refunds": "Nid oes genych eitemau wedi'u ad-dalu.",
		"select-codes": "Dewiswch y cod(au) i ad-dalu:",
		"number": "Faint?",
		"back": "Yn ôl i ad-daliadau"
	},
	"purchases": {
		"back": "Yn ôl i bryniadau"
	},
	"global-bar": {
		"account": "Gosodiadau Cyfrif"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/cy.json
 ** module id = 972
 ** module chunks = 0
 **/